module.exports = __webpack_public_path__ + "img/expeditionary-stage_1.4.3d286f3c.jpg";